// src/constants/utils.ts

export interface Course {
    title: string;
    description: string;
    icon: string;
    category: 'entrance' | 'grade' | 'board' | 'supplementary';
}

export interface Feature {
    icon: string;
    title: string;
    description: string;
    color: string;
}

export const navItems = [
    { label: "Home", href: "#home" },
    { label: "Features", href: "#features" },
    { label: "Courses", href: "#services" },
    { label: "Contact", href: "#contact" },
];

export const Cources: Course[] = [
    {
        title: "Navodaya Entrance",
        description: "Comprehensive preparation for Navodaya Vidyalaya entrance exam",
        icon: "/assets/icons/exam.svg",
        category: "entrance",
    },
    {
        title: "8th Standard",
        description: "Complete 8th grade curriculum in English & Kannada medium",
        icon: "/assets/icons/book.svg",
        category: "grade",
    },
    {
        title: "9th Standard",
        description: "Full 9th grade courses in English & Kannada medium",
        icon: "/assets/icons/laptop.svg",
        category: "grade",
    },
    {
        title: "SSLC",
        description: "Complete SSLC board exam preparation in both mediums",
        icon: "/assets/icons/teacher.svg",
        category: "board",
    },
    {
        title: "SSLC Supplementary",
        description: "Focused coaching for SSLC supplementary examinations",
        icon: "/assets/icons/exam.svg",
        category: "supplementary",
    },
];

export const features: Feature[] = [
    {
        icon: "/assets/icons/book.svg",
        title: "Multi-Grade Learning",
        description: "We offer specialized courses for 8th, 9th, and SSLC students in both mediums.",
        color: "bg-blue-100"
    },
    {
        icon: "/assets/icons/download.svg",
        title: "Offline Downloading",
        description: "Download your courses and study anytime, anywhere without internet.",
        color: "bg-green-100"
    },
    {
        icon: "/assets/icons/language.svg",
        title: "Dual Medium Support",
        description: "Complete lessons available in both English and Kannada medium.",
        color: "bg-yellow-100"
    },
    {
        icon: "/assets/icons/laptop.svg",
        title: "Entrance Exam Prep",
        description: "Specialized coaching for Navodaya and other competitive entrance exams.",
        color: "bg-purple-100"
    },
    {
        icon: "/assets/icons/teacher.svg",
        title: "Expert Teachers",
        description: "Learn from experienced educators with proven track records.",
        color: "bg-pink-100"
    },
    {
        icon: "/assets/icons/exam.svg",
        title: "Exam Success Focus",
        description: "Regular assessments and performance tracking for guaranteed results.",
        color: "bg-indigo-100"
    }
];